<template>
  <v-form class="mb-2">
    <v-container flat>
      <div v-for="(filter, index) in filterList" :key="index">
        <v-text-field
          ref="singleInput"
          :label="$t(filter.label || 'components.filter.label')"
          :type="filter.type"
          v-model="filter.value[0]"
          class="lessCompact"
          v-if="!filter.multiple"
          dense
          outlined
          rounded
        ></v-text-field>
        <v-combobox
          ref="multiInputWithSelection"
          v-model="filter.value"
          :label="$t(filter.label || 'components.filter.label')"
          :items="filter.items"
          chips
          clearable
          multiple
          outlined
          rounded
          class="compact"
          dense
          v-else-if="filter.items"
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              color="primary"
              :style="chipStyle"
              v-bind="attrs"
              :input-value="selected"
              close
              outlined
              rounded
              @click="select"
              @click:close="remove(item, index)"
            >
              {{ item }}
            </v-chip>
          </template>
        </v-combobox>
        <v-combobox
          ref="multiInput"
          v-model="filter.value"
          :label="filter.label"
          append-icon=""
          chips
          clearable
          multiple
          class="compact"
          dense
          outlined
          rounded
          v-else
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              color="closeChipColor"
              :style="closeChipStyle"
              v-bind="attrs"
              :input-value="selected"
              close
              @click="select"
              @click:close="remove(item, index)"
            >
              {{ item }}
            </v-chip>
          </template>
        </v-combobox>
        <Debug :debug="filter.value"></Debug>
      </div>
    </v-container>
  </v-form>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import Debug from "@/components/utility/Debug.vue";
import { IFilterListElement } from "@/lib/interfaces/filter/filterListElement.interface";

@Component({
  components: { Debug }
})
export default class FilterSelection extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: () => [] })
  filterList!: IFilterListElement[];

  @Prop({ default: "red" })
  closeChipColor?: string;

  @Prop({ default: "white" })
  chipFontColor?: string;

  @Prop({ default: "white" })
  closeChipFontColor?: string;

  get chipStyle() {
    return `color:${this.chipFontColor}`;
  }

  get closeChipStyle() {
    return `color:${this.closeChipFontColor}`;
  }

  remove(value: string, index: number) {
    const values = this.filterList[index].value;
    if (values) {
      const position = values.indexOf(value);
      this.filterList[index].value?.splice(position, 1);
    }
  }
}
</script>
<style scoped>
.closeChipElementText {
  margin-right: -1px;
}

.compact {
  margin-top: 2px;
  margin-bottom: 2px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.lessCompact {
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>
